import React, { FunctionComponent } from "react";

import "./deprecation-warning.scss";

export const DeprecationWarning: FunctionComponent = ({ children }) => {
    return (
        <div className="deprecation-warning">
            {children}
        </div>
    );
};
